// Minimum basket value for SHIPPED orders that contain live animals (items subtotal,
// before discounts/shipping). Food-only baskets ('standard' category) are exempt.
// Mirrors backend services/shipping.py:min_order_block — keep the two in sync.
export const MIN_ORDER_DEFAULT_MESSAGE =
  'Our minimum order for shipping is €{min}. Add €{gap} more to check out, or choose collection.';

export const minOrderBlock = (settings, totalPrice, category = 'live') => {
  if (category !== 'live') return null;
  const min = parseFloat(settings?.min_order_value) || 0;
  if (min <= 0 || totalPrice >= min) return null;
  const gap = min - totalPrice;
  const template = (settings?.min_order_message || '').trim() || MIN_ORDER_DEFAULT_MESSAGE;
  return {
    min,
    gap,
    message: template.replace(/\{min\}/g, min.toFixed(2)).replace(/\{gap\}/g, gap.toFixed(2)),
  };
};
